import { render, staticRenderFns } from "./DirectionCats.vue?vue&type=template&id=3d2c75eb"
import script from "./DirectionCats.vue?vue&type=script&lang=js"
export * from "./DirectionCats.vue?vue&type=script&lang=js"
import style0 from "./DirectionCats.vue?vue&type=style&index=0&id=3d2c75eb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports